import useFeatureFlagByNameKey from '@/shared/hooks/useFeatureFlagByNameKey/useFeatureFlagByNameKey';

const useHigherEducation = () => {
  const { valueFeatureFlag, loading } = useFeatureFlagByNameKey(
    'MARKETPLACE_DISPLAY',
  );

  return {
    isHigherEducationActive: valueFeatureFlag,
    isLoadingHigherEducation: loading,
  };
};

export default useHigherEducation;
